/**
 * Shop Menu
 * Simple smooth scrolling implementation
 */
document.addEventListener('DOMContentLoaded', function() {
  // Menu toggle functionality
  const hamburgerMenu = document.querySelector('.hamburger-menu span');
  const shopMenu = document.querySelector('.shop-menu');
  const closeMenu = document.querySelector('.close-menu');
  const menuOverlay = document.querySelector('.menu-overlay');
  
  if (hamburgerMenu && shopMenu && closeMenu && menuOverlay) {
    // Open menu when hamburger is clicked
    hamburgerMenu.addEventListener('click', function() {
      shopMenu.classList.add('active');
      menuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
    });
    
    // Close menu when close button is clicked
    closeMenu.addEventListener('click', function() {
      closeMenuWithAnimation();
    });
    
    // Close menu when overlay is clicked
    menuOverlay.addEventListener('click', function() {
      closeMenuWithAnimation();
    });
    
    // Handle escape key to close menu
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && shopMenu.classList.contains('active')) {
        closeMenuWithAnimation();
      }
    });
    
    // Function to handle smooth menu closing
    function closeMenuWithAnimation() {
      shopMenu.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Re-enable scrolling
    }
  }
  
  // Handle menu items with children (dropdowns)
  const parentMenus = document.querySelectorAll('.menu-pages .parent-menu');
  const parentTitles = document.querySelectorAll('.menu-pages .parent-title');
  const dropdownIcons = document.querySelectorAll('.menu-pages .dropdown-icon');
  
  // Function to toggle dropdown
  function toggleDropdown(element) {
    const hasChildrenElement = element.closest('.has-children');
    if (!hasChildrenElement) return;
    
    const dropdownContent = hasChildrenElement.querySelector('.dropdown-content');
    const dropdownIcon = hasChildrenElement.querySelector('.dropdown-icon');
    
    if (dropdownContent && dropdownIcon) {
      // Toggle active class for dropdown content
      dropdownContent.classList.toggle('active');
      dropdownIcon.classList.toggle('active');
      
      // Close other dropdowns
      document.querySelectorAll('.menu-pages .has-children').forEach(otherItem => {
        if (otherItem !== hasChildrenElement) {
          const otherContent = otherItem.querySelector('.dropdown-content');
          const otherIcon = otherItem.querySelector('.dropdown-icon');
          
          if (otherContent && otherContent.classList.contains('active')) {
            otherContent.classList.remove('active');
            otherIcon.classList.remove('active');
          }
        }
      });
    }
  }
  
  // Add click events to parent menus
  if (parentMenus.length > 0) {
    parentMenus.forEach(menu => {
      menu.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown(this);
      });
    });
  }
  
  // Add click events to parent titles
  if (parentTitles.length > 0) {
    parentTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown(this);
      });
    });
  }
  
  // Add click events to dropdown icons
  if (dropdownIcons.length > 0) {
    dropdownIcons.forEach(icon => {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown(this);
      });
    });
  }
});